export default __webpack_public_path__ + "static/media/rolling.a03a10c1.gif";